<template>
<div class="rd-root" :style="themePageStyle">

  <nav class="rd-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/market')"><i class="mdi mdi-arrow-left" style="color:var(--fm-m,#A09888);font-size:22px;"></i></a>
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:30px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">Market Report</span>
    </div>
    <div class="d-flex gap-2">
      <a v-if="report && report.pdf_url" :href="pdfHref" target="_blank" class="btn btn-sm btn-outline-warning" @click="trackDownload">
        <i class="mdi mdi-download me-1"></i>Download PDF
      </a>
      <button class="btn btn-sm btn-warning" @click="$router.push('/market')"><i class="mdi mdi-chart-line me-1"></i>All Reports</button>
    </div>
  </div></nav>

  <div class="container rd-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!report" class="text-center py-5">
      <i class="mdi mdi-file-question-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Report not found</h5>
      <p style="color:var(--fm-s,#6B6356);">{{ error || 'It may have been unpublished or removed.' }}</p>
      <button class="btn btn-warning" @click="$router.push('/market')">Browse all reports</button>
    </div>

    <div v-else>
      <!-- Cover -->
      <div v-if="report.cover_image_url" class="rd-cover" :style="'background-image:url('+imgUrl(report.cover_image_url)+')'"></div>

      <!-- Header -->
      <div class="rd-header">
        <span class="rd-type">{{ report.report_type }}</span>
        <h2 class="rd-title">{{ report.title }}</h2>
        <div class="rd-meta">
          <span><i class="mdi mdi-calendar me-1"></i>{{ report.report_date }}</span>
          <span v-if="report.county_name">· <i class="mdi mdi-map-marker me-1"></i>{{ report.county_name }}</span>
          <span v-if="report.species_name">· <i class="mdi mdi-cow me-1"></i>{{ report.species_name }}</span>
          <span v-if="report.published_at">· Published {{ report.published_at.split(' ')[0] }}</span>
        </div>
        <div class="rd-stats">
          <span><i class="mdi mdi-eye-outline me-1"></i>{{ report.view_count }} view{{ report.view_count===1?'':'s' }}</span>
          <span v-if="report.download_count"><i class="mdi mdi-download me-1"></i>{{ report.download_count }} download{{ report.download_count===1?'':'s' }}</span>
        </div>
      </div>

      <!-- Body — admins author HTML so we render as-is (within the same site, single-author trust model). -->
      <div class="rd-body" v-html="report.content"></div>

      <!-- Footer CTA -->
      <div class="rd-footer">
        <button class="btn btn-outline-warning" @click="$router.push('/market')">
          <i class="mdi mdi-arrow-left me-1"></i>Back to all reports
        </button>
        <a v-if="report.pdf_url" :href="pdfHref" target="_blank" class="btn btn-warning" @click="trackDownload">
          <i class="mdi mdi-download me-1"></i>Download PDF
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .rd-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .rd-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .rd-body{color:#1A1A1A!important}
</style>

<style scoped>
.rd-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.rd-topbar{position:sticky;top:0;z-index:100;padding:10px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.rd-container{padding-top:80px;padding-bottom:60px;max-width:780px}
.rd-cover{height:240px;background-size:cover;background-position:center;border-radius:14px;margin-bottom:20px;background-color:var(--fm-bg1,#141414)}
.rd-header{margin-bottom:24px}
.rd-type{display:inline-block;padding:3px 10px;border-radius:6px;background:rgba(191,161,100,.12);color:#BFA164;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px}
.rd-title{color:var(--fm-h,#F5F0E8);font-weight:700;line-height:1.3;margin-bottom:10px}
.rd-meta{color:var(--fm-m,#A09888);font-size:13px;display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px}
.rd-stats{color:var(--fm-s,#6B6356);font-size:11px;display:flex;gap:14px}
.rd-body{color:var(--fm-h,#F5F0E8);font-size:15px;line-height:1.7}
.rd-body :deep(h1),.rd-body :deep(h2),.rd-body :deep(h3){color:var(--fm-h,#F5F0E8);margin-top:1.5em;margin-bottom:.5em}
.rd-body :deep(p){margin-bottom:1em;color:var(--fm-h,#F5F0E8)}
.rd-body :deep(ul),.rd-body :deep(ol){margin-bottom:1em;padding-left:1.4em}
.rd-body :deep(li){margin-bottom:.4em}
.rd-body :deep(a){color:#BFA164;text-decoration:underline}
.rd-body :deep(blockquote){border-left:3px solid #BFA164;padding-left:14px;margin:1em 0;color:var(--fm-m,#A09888);font-style:italic}
.rd-body :deep(table){width:100%;border-collapse:collapse;margin:1em 0;font-size:13px}
.rd-body :deep(th),.rd-body :deep(td){border:1px solid var(--fm-br,#1E1E1E);padding:8px 12px;text-align:left}
.rd-body :deep(th){background:var(--fm-bg2,#0F0F0F);color:#BFA164}
.rd-body :deep(img){max-width:100%;border-radius:8px;margin:1em 0}
.rd-footer{margin-top:40px;padding-top:20px;border-top:1px solid var(--fm-br,#1E1E1E);display:flex;gap:10px;justify-content:space-between;flex-wrap:wrap}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";

export default {
  name: "MarketReportDetail",
  data(){return{
    darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark') !== 'light',
    themeObserver: null,
    loading: true, error: '',
    report: null
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    pdfHref(){
      if (!this.report || !this.report.pdf_url) return '#';
      var u = this.report.pdf_url;
      return u.indexOf('http') === 0 ? u : (uploads + String(u).replace(/^uploads\//, ''));
    }
  },
  watch: {
    '$route.params.idOrSlug'(){ this.load(); }
  },
  mounted(){
    this._applyThemeOnce();
    var self = this;
    this.themeObserver = new MutationObserver(function(){ try { self._applyThemeOnce(); } catch(e) {} });
    this.themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    this.load();
  },
  beforeUnmount(){
    if (this.themeObserver) { this.themeObserver.disconnect(); this.themeObserver = null; }
  },
  methods:{
    _applyThemeOnce(){
      var current = document.documentElement.getAttribute('data-theme');
      var desired = (localStorage.getItem('flockr_theme') || current || 'dark');
      if (current !== desired) document.documentElement.setAttribute('data-theme', desired);
      this.darkMode = desired !== 'light';
    },
    imgUrl(u){ if(!u) return ''; if(u.indexOf('http')===0) return u; return uploads + String(u).replace(/^uploads\//, ''); },
    async load(){
      this.loading = true; this.error = ''; this.report = null;
      var idOrSlug = this.$route.params.idOrSlug;
      var params = { function:'getMarketReportDetail' };
      // Numeric → reportId, otherwise treat as slug
      if (/^\d+$/.test(idOrSlug)) params.reportId = idOrSlug;
      else params.slug = idOrSlug;
      try {
        var r = await executeJson(params, flocker);
        if (r.data && r.data.success && r.data.data && r.data.data.report) {
          this.report = r.data.data.report;
        } else {
          this.error = (r.data && r.data.message) || 'Report not found';
        }
      } catch(e){
        this.error = (e && e.message) || 'Network error — please try again';
      }
      this.loading = false;
    },
    async trackDownload(){
      if (!this.report) return;
      // Fire-and-forget — we let the browser handle the actual download in parallel
      try { await executeJson({ function:'trackMarketReportDownload', reportId: this.report.id }, flocker); } catch(e){}
    }
  }
};
</script>
